import { extendTheme } from "@chakra-ui/react";
const breakpoints = {
    xs: '280px',
    sm: '320px',
    ls: '688px',
    md: '768px',
    lg: '960px',
    xl: '1200px',
    '2xl': '1536px',
  }

export const theme = extendTheme({
    styles:{
        global:{
            'body':{
                bgGradient:'linear-gradient(180deg, hsla(70, 100%, 86%, 1) 0%, hsla(20, 100%, 96%, 1) 100%)',
                color: '#535353',
                fontFamily: 'Quicksand',
            },
        }
    },
    breakpoints,
})